// @flow
import { error } from './common';
import * as types from '../types/trips';
import type {
  TRIP_TYPE,
  TRIP_STOP_TYPE,
  TRIPS_FETCH_STARTED_TYPE,
  TRIPS_FETCH_SUCCEED_TYPE,
  TRIP_ADDED_TYPE,
  TRIP_REMOVED_TYPE,
  TRIP_SELECTED_TYPE,
  TRIP_COMPLETED_TYPE,
  TRIP_OPENED_TYPE,
  TRIP_CLOSED_TYPE,
  TRIP_STOP_COMPLETED_TYPE,
  TRIP_STOPS_FETCH_STARTED_TYPE,
  TRIP_STOPS_FETCH_SUCCEED_TYPE,
  TRIP_STOP_REMOVED_TYPE,
  TRIP_STOP_ADDED_TYPE,
  TRIP_STOP_UPDATED_TYPE,
  TRIPS_ADMIN_FETCH_STARTED_TYPE,
  TRIPS_ADMIN_FETCH_SUCCESS_TYPE,
  SINGLE_TRIP_FETCH_STARTED_TYPE,
  TRIP_DETAIL_HIDDEN_TYPE,
  TRIP_DETAIL_SHOWN_TYPE,
  TRIP_CREATION_STARTED_TYPE,
  TAKE_TRIP_ASSISTANCE_STARTED_TYPE,
  TAKE_TRIP_ASSISTANCE_SUCCEED_TYPE,
  TRIP_UPDATED_TYPE,
  TRIPS_SCHOOL_FETCH_STARTED_TYPE,
  TRIPS_SCHOOL_FETCH_SUCCESS_TYPE,
  FINISH_TRIP_STARTED_TYPE,
  FINISH_TRIP_SUCCEED_TYPE,
  FINISH_TRIP_FAILED_TYPE,
} from '../types/trips';

import type {
  ID_TYPE,
  ERROR_TYPE,
} from '../types/common';

export const startFetchCurrentTrip = (): SINGLE_TRIP_FETCH_STARTED_TYPE => ({
  type: types.SINGLE_TRIP_FETCH_STARTED,
  payload: id,
});

export const startFetchSingleTrip = (id: number): SINGLE_TRIP_FETCH_STARTED_TYPE => ({
  type: types.SINGLE_TRIP_FETCH_STARTED,
  payload: id,
});

export const startFetchSchoolTrips = (schoolId: number): TRIPS_SCHOOL_FETCH_STARTED_TYPE => ({
  type: types.TRIPS_SCHOOL_FETCH_STARTED,
  payload: {
    schoolId,
  },
});

export const successFetchSchoolTrips = (
  entities: {[number]: TRIP_TYPE},
  order: Array<number>,
): TRIPS_SCHOOL_FETCH_SUCCESS_TYPE => ({
  type: types.TRIPS_SCHOOL_FETCH_SUCCESS,
  payload: {
    entities,
    order,
  },
});

export const startFetchAdminTrips = (userId: number): TRIPS_ADMIN_FETCH_STARTED_TYPE => ({
  type: types.TRIPS_ADMIN_FETCH_STARTED,
  payload: {
    userId,
  },
});

export const successFetchAdminTrips = (
  entities: {[number]: TRIP_TYPE},
  order: Array<number>,
): TRIPS_ADMIN_FETCH_SUCCESS_TYPE => ({
  type: types.TRIPS_ADMIN_FETCH_SUCCESS,
  payload: {
    entities,
    order,
  },
});

export const successFetchCurrentTrip = (
  entities: {[number]: TRIP_TYPE},
): TRIPS_FETCH_SUCCEED_TYPE => ({
  type: types.TRIPS_FETCH_SUCCEED,
  payload: {
    entities,
  },
});

export const failCurrentTripFetch = error(types.TRIPS_FETCH_FAILED);

export const addTrip = (
  id: number,
  route: number,
  name: string,
  short_name: string,
  bus: number,
  monitor: number,
  stops: Array<number>,
  school: number,
  is_completed: boolean,
  trip_type: 'going' | 'returning',
): TRIP_ADDED_TYPE => ({
  type: types.TRIP_ADDED,
  payload: {
    id,
    route,
    name,
    short_name,
    bus,
    monitor,
    stops,
    school,
    is_completed,
    trip_type,
  },
});

export const removeTrip = (id: number): TRIP_REMOVED_TYPE => ({
  type: types.TRIP_REMOVED,
  payload: id,
});

export const setCurrentTrip = (id: number): TRIP_SELECTED_TYPE => ({
  type: types.TRIP_SELECTED,
  payload: id,
});

export const fetchTripsSucceed = (
  entities: {[number]: TRIP_TYPE},
  order: Array<number>,
): TRIPS_FETCH_SUCCEED_TYPE => ({
  type: types.TRIPS_FETCH_SUCCEED,
  payload: {
    entities,
    order,
  },
});

export const fetchTripsFailed = error(types.TRIPS_FETCH_FAILED);

export const fetchTripFailed = error(types.TRIP_FETCH_FAILED);
// export const deselectTrip = (id: number): TRIP_DESELECTED_TYPE => ({
//   type: types.TRIP_DESELECTED,
//   payload: id
// });

export const openTrip = (id: number): TRIP_OPENED_TYPE => ({
  type: types.TRIP_OPENED,
  payload: {
    id,
    isOpen: true,
  },
});

export const closeTrip = (id: number): TRIP_CLOSED_TYPE => ({
  type: types.TRIP_CLOSED,
  payload: {
    id,
    isOpen: false,
  },
});


export const openTripDetail = (id: number): TRIP_DETAIL_SHOWN_TYPE => ({
  type: types.TRIP_DETAIL_SHOWN,
  payload: {
    id,
    isShowingDetail: true,
  },
});

export const closeTripDetail = (id: number): TRIP_DETAIL_HIDDEN_TYPE => ({
  type: types.TRIP_DETAIL_HIDDEN,
  payload: {
    id,
    isShowingDetail: false,
  },
});


export const completeTrip = (id: number): TRIP_COMPLETED_TYPE => ({
  type: types.TRIP_COMPLETED,
  payload: {
    id,
    is_completed: true,
  },
});

export const startTripStopsFetch = (id: number): TRIP_STOPS_FETCH_STARTED_TYPE => ({
  type: types.TRIP_STOPS_FETCH_STARTED,
  payload: {
    id,
  },
});

export const succeedTripStopsFetch = (
  entities: {[number]: TRIP_STOP_TYPE},
): TRIP_STOPS_FETCH_SUCCEED_TYPE => ({
  type: types.TRIP_STOPS_FETCH_SUCCEED,
  payload: {
    entities,
  },
});

export const failTripStopsFetch = error(types.TRIP_STOPS_FETCH_FAILED);

export const completeTripStop = (id: number): TRIP_STOP_COMPLETED_TYPE => ({
  type: types.TRIP_STOP_COMPLETED,
  payload: {
    id,
    is_completed: true,
  },
});

export const removeTripStop = (id: number): TRIP_STOP_REMOVED_TYPE => ({
  type: types.TRIP_STOP_REMOVED,
  payload: id,
});

export const addTripStop = (
  trip_stop: TRIP_STOP_TYPE,
): TRIP_STOP_ADDED_TYPE => ({
  type: types.TRIP_STOP_ADDED,
  payload: trip_stop,
});

export const updateTripStop = (id: number, data: TRIP_STOP_TYPE): TRIP_STOP_UPDATED_TYPE => ({
  type: types.TRIP_STOP_UPDATED,
  payload: {
    id,
    ...data,
  },
});

export const createTrip = (): TRIP_CREATION_STARTED_TYPE => ({
  type: types.TRIP_CREATION_STARTED,
});

export const failTripCreation = error(types.TRIP_CREATION_FAILED);

export const takeTripAssistance = (): TAKE_TRIP_ASSISTANCE_STARTED_TYPE => ({
  type: types.TAKE_TRIP_ASSISTANCE_STARTED,
});

export const succeedTakeTripAssistance = (): TAKE_TRIP_ASSISTANCE_SUCCEED_TYPE => ({
  type: types.TAKE_TRIP_ASSISTANCE_SUCCEED,
});

export const failTakeTripAssistance = error(types.TAKE_TRIP_ASSISTANCE_FAILED);

export const updateTrip = (id: number, attributes: Object): TRIP_UPDATED_TYPE => ({
  type: types.TRIP_UPDATED,
  payload: {
    id,
    ...attributes,
  },
});

export const finishTripStarted = (tripId: ID_TYPE): FINISH_TRIP_STARTED_TYPE => ({
  type: types.FINISH_TRIP_STARTED,
  payload: tripId,
});

export const finishTripSucceed = (): FINISH_TRIP_SUCCEED_TYPE => ({
  type: types.FINISH_TRIP_SUCCEED,
});

export const finishTripFailed = (err: ERROR_TYPE): FINISH_TRIP_FAILED_TYPE => ({
  type: types.FINISH_TRIP_FAILED,
  payload: err,
});



// WEBPACK FOOTER //
// ./src/scripts/actions/trips.js